var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React from 'react';
import { Outlet, matchPath } from 'react-router';
import RouteHandler from "../App/RouteHandler";
import { actions } from "../BasicReducer";
import { enterLibrary, unsetDocuments, zoomIn, zoomOut } from "./actions/libraryActions";
import { wrapDispatch } from "../Multireducer";
import { withRouter } from "../componentWrappers";
import { routes as appRoutes } from "../appRoutes";

class LibraryRootComponent extends RouteHandler {
  constructor(props, context) {
    super(props, context);_defineProperty(this, "findMatchingRoute",






















    (pathname, routes, parentPath = '') => {
      let result = null;

      routes.every((route) => {
        if (result !== null) {
          return false;
        }

        const currentPath = `${parentPath}/${route.path || ''}`.replace('//', '/');
        const match = matchPath({ path: currentPath, end: false }, pathname);

        if (match) {var _route$handle;
          if (currentPath === pathname && (_route$handle = route.handle) !== null && _route$handle !== void 0 && _route$handle.library) result = route;

          if (route.children) {
            const childMatch = this.findMatchingRoute(pathname, route.children, currentPath);
            if (childMatch) result = childMatch;
          }
        }
        return true;
      });

      return result;
    });this.superComponentWillReceiveProps = super.componentWillReceiveProps;const { dispatch } = context.store;wrapDispatch(dispatch, 'library')(enterLibrary());this.zoomIn = () => wrapDispatch(dispatch, 'library')(zoomIn());this.zoomOut = () => wrapDispatch(dispatch, 'library')(zoomOut());this.scrollCallback = this.scrollCallback.bind(this);this.state = { scrollCount: 0 };}urlHasChanged(nextProps) {const nextSearchParams = new URLSearchParams(nextProps.location.search);const currentSearchParams = new URLSearchParams(this.props.location.search);return nextSearchParams.get('q') !== currentSearchParams.get('q');}componentDidUpdate(prevProps) {if (this.urlHasChanged(prevProps)) {this.getClientState(this.props);}}

  componentWillUnmount() {var _window, _window$location;
    const nextLocation = (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.pathname;
    const matchedRoute = this.findMatchingRoute(nextLocation, appRoutes);
    if (!matchedRoute && !nextLocation.includes('library')) {
      this.emptyState();
    }
  }

  emptyState() {
    wrapDispatch(this.context.store.dispatch, 'library')(unsetDocuments());
    actions.set('library.sidepanel.quickLabelState', {});
  }

  scrollCallback(event) {
    if (event.target.className.includes('document-viewer')) {
      this.setState((prevState, _props) => ({
        scrollCount: prevState.scrollCount + 1
      }));
    }
  }

  render() {
    if (this.props.children) {
      return this.props.children;
    }

    return /*#__PURE__*/_jsx(Outlet, {});
  }
}

const SSRLibrary = withRouter(LibraryRootComponent);

export const LibraryRoot = Object.assign(SSRLibrary, {
  requestState: LibraryRootComponent.requestState
});

export { LibraryRootComponent };
export default LibraryRoot;